import Reflux from 'reflux';

export default Reflux.createActions({
  updateBoardGrid: {},
  clearChartData: {},
  getBoardWithWidgets: {},
  updateBoardSystem: {},
});
